import "./KeyAdvantages.css";

const KeyAdvantages = () => {
  return (
    <div className="key-advantage-section1">
      <div className="advantage-header">
        <h3 className="advantage-title_v1_kf">Key Advantages</h3>
        <p className="advantage-subtext_v1_kf">
          We value your trust-Simple, fast, and reliable personal loans.
        </p>
      </div>
      <img src="assets/img/Group 428.png" class="key-advantages-kf" alt="key-advantages"></img>
    </div>
  );
};

export default KeyAdvantages;
